export { default as PropertyInvest } from './PropertyInvest'
